<div class="content">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

    <ng-container matColumnDef="lastname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="lastname" > Nom
        </th>
        <td mat-cell *matCellDef="let element" class="cell_code_club"> {{element.clubRessourceLastName}} </td>
    </ng-container>
    <ng-container matColumnDef="firstname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="firstname" > Prénom
        </th>
        <td mat-cell *matCellDef="let element" class="cell_code_club"> {{element.clubRessourceFirstName}} </td>
    </ng-container>

    <ng-container matColumnDef="pseudo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="pseudo" class="cell_club">Pseudo</th>
        <td mat-cell *matCellDef="let element" class="cell_club"> {{element.clubRessourcePseudo}} </td>
    </ng-container>

    <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="isActive" class="cell_action">Act./Dés.</th>
        <td mat-cell *matCellDef="let element" class="cell_club"> 
            <mat-slide-toggle [color]="color" [checked]="element.isActive" (toggleChange)="activeOrDeactiveResource()"></mat-slide-toggle>
        </td>
    </ng-container>

    <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Editer </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
            <fa-icon [icon]="getFaIcon('faPen')"
                (click)="addOrEditResource('edit',  element)" appChangeColorTheme attribute="color">
            </fa-icon>
        </td>
    </ng-container>

    

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
</table>
<div class="no_resource" *ngIf="!dataSource?.filteredData.length">
    Aucune ressource
</div>
<mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    (page)="pageEvent = $event" [color]="color">
</mat-paginator>
</div>
